<template>
	<div class="base-info flex start-v">
		<div class="form">
			<p class="head flex between">
				<span>个人信息</span>
			</p>
			<div class="row flex between">
				<span>姓名：</span>
				<span>{{userInfo.name}}</span>
			</div>
			<div class="row flex between">
				<span>性别：</span>
				<span>{{gender[userInfo.sex]}}</span>
			</div>
			<div class="row flex between">
				<span>所在组别：</span>
				<span>{{gradeList[userInfo.studentGroup]}}</span>
			</div>
			<div class="row flex between">
				<span>学号：</span>
				<span>{{userInfo.studentNumber}}</span>
			</div>
			<!-- <div class="row flex between">
				<span>学院：</span>
				<span>xxxxx学院</span>
			</div> -->
			<div class="row flex between">
				<span>专业班级：</span>
				<span>{{userInfo.professionalClass}}</span>
			</div>
			<div class="row flex between">
				<span>上一学期体育成绩：</span>
				<span>{{userInfo.lastAcademicYearScore}}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			gender:["女","男"],
			gradeList:["不及格组","提高组","高级组"],
			userInfo: {},
		};
	},
	mounted(){
		this.getUserInfo();
	},
	methods: {
		async getUserInfo() {
			try {
				let {success,message,result} = await this.$http.get(`h5/my/studentInfo`)
				if (!success) throw new Error(message);
				this.userInfo = result;
			} catch (error) {
				console.error("getUserInfo", error?.message);
			}
		},
	},
};
</script>

<style scoped lang="less">
.base-info {
	height: 100%;
	padding: 17 / @rem;
	.head {
		align-items: flex-start;
		span:first-child {
			font-size: 17 / @rem;
			font-weight: bold;
			color: rgba(31, 30, 29, 1);
			&::after {
				content: "";
				display: block;
				width: 36 / @rem;
				height: 3 / @rem;
				margin-top: 5 / @rem;
				border-radius: 3 / @rem;
				background-color: rgba(255, 162, 22, 1);
			}
		}
	}
	.form{
		width: 100%;
		padding-bottom: 20/@rem;
		flex: 1;
		overflow-y: auto;
	}
	.row {
		padding-top: 5 / @rem;
		height: 67 / @rem;
		border-bottom: 1 / @rem solid rgba(17, 17, 16, 0.1);
		span {
			color: rgba(31, 30, 29, 0.6);
			font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular;
		}
		span:last-child {
			flex: 1;
			color: rgba(17, 17, 16, 1);
		}
	}
}
</style>
